import { style } from '@mui/system';
import React, {forwardRef} from 'react';
import "./FlexWrapper.scss";

const FlexWrapper = forwardRef(({id, children, gap, columnGap, rowGap, direction, wrap, justify, align, className, onClick, fullWidth, flex, style, noShrink }, ref) => {
	let wrapperClass = "";

	if (className) {
		wrapperClass += " " + className;
	}
	
	if (gap) {
		wrapperClass += " flex-wrapper-gap-" + gap;
	}
	if (columnGap) {
		wrapperClass += " flex-wrapper-column-gap-" + columnGap;
	}
	if (rowGap) {
		wrapperClass += " flex-wrapper-row-gap-" + rowGap;
	}
	return (
		<div
			ref={ref}
			onClick={onClick}
			style={{ ...style, display: "flex", flex: flex, flexDirection: direction, flexWrap: wrap && "wrap", justifyContent: justify, alignItems: align ? align : "center", width: fullWidth ? "100%" : "", flexShrink: noShrink ? 0 : '' }}
			className={wrapperClass}
			id={id}
		>
			{children}
		</div>
	);
});
export default FlexWrapper;